import React from 'react';

const ReaderView = ({ projects, urlFor, setReaderView }) => {
  return (
    <div className="reader-view">
      <button
        className="toggle-button"
        onClick={() => setReaderView(false)}
      >
        Switch to Gameboy View
      </button>
      <h1>Projects</h1>
      {projects.map((project) => (
        <div key={project._id} className="project-card">
          <h2>{project.title}</h2>
          {project.image && (
            <img
              src={urlFor(project.image).width(600).url()}
              alt={project.title}
            />
          )}
          <p>{project.description}</p>
          {project.howIDidIt && (
            <p>
              <strong>How I did it:</strong>
              <br />
              {project.howIDidIt}
            </p>
          )}
          {project.url && (
            <p>
              <a href={project.url} target="_blank" rel="noreferrer">
                View Project
              </a>
            </p>
          )}
          {project.video && (
            <p>
              <a href={project.video} target="_blank" rel="noreferrer">
                Watch Video
              </a>
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReaderView;